import { Injectable } from '@angular/core';
import { BT } from '../../models/models';

@Injectable()
export class BtLocalService {
  constructor() {
  }

  public static deleteBT(): void {
    localStorage.removeItem('BT');
  }

  public static getBT(): BT {
    return JSON.parse(localStorage.getItem('BT'));
  }

  public static setBT(bt: BT) {
    localStorage.setItem('BT', JSON.stringify(bt));
  }
}



// WEBPACK FOOTER //
// ./src/app/core/local-data-services/bt-local.service.ts